import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { motion } from "framer-motion";

// Pastikan Anda telah meng-import "leaflet/dist/leaflet.css" di index.tsx atau App.tsx

const MapWidget = () => {
  const position: [number, number] = [-6.200000, 106.816666]; // Contoh: Jakarta

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.3 }}
      style={{ width: "100%" }}
    >
      <Card>
        <CardContent>
          <Typography variant="h5" fontWeight="bold">
            Project Locations
          </Typography>
          <Typography variant="body2" color="textSecondary" mb={2}>
            View current project locations on the map.
          </Typography>
          <div style={{ width: "100%", height: 300 }}>
            <MapContainer center={position} zoom={10} style={{ width: "100%", height: "100%" }}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={position}>
                <Popup>Example Project Location</Popup>
              </Marker>
            </MapContainer>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default MapWidget;
